import React from "react";
import axiosResiInstance from "../http/axiosResi";
import { reviewSortOptions } from "../components/agent/Reviews/ReviewSort";

// STATUS
export const STATUS_PENDING = "pending";
export const STATUS_HIDDEN = "hidden";
export const STATUS_APPROVED = "approved";
export const STATUS_REPORTED = "reported";

// STARS
export const STAR_0_0 = 0;
export const STAR_0_5 = 0.5;
export const STAR_1_0 = 1;
export const STAR_1_5 = 1.5;
export const STAR_2_0 = 2;
export const STAR_2_5 = 2.5;
export const STAR_3_0 = 3;
export const STAR_3_5 = 3.5;
export const STAR_4_0 = 4;
export const STAR_4_5 = 4.5;
export const STAR_5_0 = 5;

// USER EXPERIENCES
export const EXPERIENCE_EXPERTISE = "expertise";
export const EXPERIENCE_COMMUNICATION = "communication";
export const EXPERIENCE_SPEED = "speed";
export const EXPERIENCE_KNOWLEDGE = "knowledge";

export const EXPERIENCE_LABELS = {
    [EXPERIENCE_EXPERTISE]: "Area Expertise",
    [EXPERIENCE_COMMUNICATION]: "Communication Skills",
    [EXPERIENCE_SPEED]: "Process Speed",
    [EXPERIENCE_KNOWLEDGE]: "Real Estate Knowledge",
};

export const SERVICES = [
    { value: "buying", label: "Real Estate Sale (Buying)" },
    { value: "selling", label: "Real Estate Sale (Selling)" },
    { value: "renting", label: "Real Estate Lease (Renting)" },
    { value: "listing", label: "Real Estate Lease (Listing)" },
    { value: "consultation", label: "Real Estate Consultation" },
    { value: "other", label: "Real Estate Other" },
];

export const REPORT_PROBLEMS = [
    { value: "inaccurate", label: "Inaccurate review" },
    { value: "offensive", label: "Offensive language" },
    { value: "fake", label: "Appears fake" },
    { value: "inappropriate_reply", label: "Inappropriate agent reply" },
];

export const getRatingLabel = (rating) => {
    if (rating >= STAR_4_5) {
        return "Highly likely to recommend";
    }

    if (rating >= STAR_3_5) {
        return "Likely to recommend";
    }

    if (rating >= STAR_2_5) {
        return "Might recommend";
    }

    if (rating >= STAR_1_5) {
        return "Unlikely to recommend";
    }

    if (rating >= STAR_1_0) {
        return "Never recommend";
    }

    return "No rating";
};

// REVIEW(S)
// ------------------
export const fetchAgentReviews = (
    agentId,
    pageSize,
    page = 1,
    sort = reviewSortOptions[0].value
) => {
    return axiosResiInstance.get(`/agents/${agentId}/reviews`, {
        params: {
            sort,
            offset: (page - 1) * pageSize,
            limit: pageSize,
        },
    });
};

export const fetchUserReview = (agentId) => {
    return axiosResiInstance.get(`/agents/${agentId}/user/review`);
};

export const createAgentReview = (agentId, data) => {
    return axiosResiInstance.post(`/agents/${agentId}/reviews`, data);
};

export const updateAgentReview = (agentId, reviewId, data) => {
    return axiosResiInstance.put(
        `/agents/${agentId}/reviews/${reviewId}`,
        data
    );
};

export const deleteAgentReview = (agentId, reviewId) => {
    return axiosResiInstance.delete(`/agents/${agentId}/reviews/${reviewId}`);
};

// REPORT
// ------------------
export const createAgentReviewReport = (agentId, reviewId, data) => {
    return axiosResiInstance.post(
        `/agents/${agentId}/reviews/${reviewId}/reports`,
        data
    );
};

// REPLY
// ------------------
export const createAgentReviewReply = (agentId, reviewId, data) => {
    return axiosResiInstance.post(
        `/agents/${agentId}/reviews/${reviewId}/replies`,
        data
    );
};

export const updateAgentReviewReply = (agentId, reviewId, $replyId, data) => {
    return axiosResiInstance.put(
        `/agents/${agentId}/reviews/${reviewId}/replies/${$replyId}`,
        data
    );
};

export const deleteAgentReviewReply = (agentId, reviewId, $replyId) => {
    return axiosResiInstance.delete(
        `/agents/${agentId}/reviews/${reviewId}/replies/${$replyId}`
    );
};
